import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/Button';
import { Grid } from 'components/Grid';
import { HeadingBoundary } from 'components/Heading';
import { SectionHeader } from 'patterns/SectionHeader';
import { cx } from 'utility';
import * as styles from './CTA.module.scss';

const propTypes = {
    buttonText: PropTypes.string,
    buttonUrl: PropTypes.object,
    className: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
};

const defaultProps = {
    buttonText: '',
    buttonUrl: {},
    className: '',
    description: '',
    title: '',
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['cta'],
    );

    return classes || undefined;
}

function CTA({
    buttonText,
    buttonUrl,
    className,
    description,
    title,
}) {
    const classes = getClasses({ className });

    return (
        <div className={classes}>
            <HeadingBoundary>
                <Grid background={true} className={styles['grid']} block={true} highlight={true}>
                    {(description || title) && (
                        <SectionHeader
                            className={styles['sectionHeader']}
                            description={description}
                            title={title}
                        />
                    )}
                    {(buttonText && (buttonUrl?.url || buttonUrl?.uid)) && (
                        <div className={styles['buttonContainer']}>
                            <Button className={styles['button']} color="secondary" showExternalIcon={false} to={buttonUrl}>{buttonText}</Button>
                        </div>
                    )}
                </Grid>
            </HeadingBoundary>
        </div>
    );
}

CTA.propTypes = propTypes;
CTA.defaultProps = defaultProps;

export { CTA };
